import { useResolutionExhibitTypeOptions } from 'hooks/useResolutionExhibitTypeOptions';
import { ItemDropDown } from './ItemEdit';

interface Props {
  value: string;
  onChange: (val: string) => void;
}

export const ActionStatusEdit = ({ value, onChange }: Props) => {
  const { defaultWorkflowStatusOptions } = useResolutionExhibitTypeOptions();

  return (
    <ItemDropDown
      value={value}
      addEmptyItem
      options={defaultWorkflowStatusOptions}
      onChange={onChange}
    />
  );
};
